(function () {
    'use strict';

    angular
        .module('app')
        .controller('ItemImportReportDialogCtrl', ItemImportReportDialogCtrl);

    ItemImportReportDialogCtrl.$inject = ['DialogInstance', 'DialogService', 'importReportData'];

    /**
     * @ngdoc Controller
     * @description
     * Dialog showing a report for item import.
     */
    function ItemImportReportDialogCtrl(DialogInstance, DialogService, importReportData) {
        /* jshint validthis:true */
        var vm = this;
        vm.ok = ok;

        activate();

        function activate() {
            vm.addedCount = _.filter(importReportData, { ImportError: null, Action: 'Insert' }).length;
            vm.updatedCount = _.filter(importReportData, { ImportError: null, Action: 'Update' }).length;
            vm.errorCount = _.filter(importReportData, function (n) { return n.ImportError; }).length;
            vm.errors = _.filter(importReportData, function (n) { return n.ImportError; });
        }

        function ok() {
            DialogInstance.ok();
        }
    }
})();